import SpriteSymbol from "../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/_svg-sprite-loader@4.3.0@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-checkbox",
  "use": "icon-checkbox-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-checkbox\"><defs><style type=\"text/css\"></style></defs><path d=\"M863.576287 208.933543 426.318572 673.529907 128.084167 464.780559 64.132646 496.746598 447.865307 848.494801 959.52557 208.933543Z\" p-id=\"2096\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol